var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"description",class:{'description--warning':_vm.type == 'warning', 'description--success':_vm.type == 'success', 'description--cancel':_vm.type == 'cancel'}})
}
var staticRenderFns = []

export { render, staticRenderFns }